/** Quick-pick chips for the place pickers. Search itself is India-wide via /api/geocode. */
export const LOCATION_PRESETS = [
  { name: "Visakhapatnam (Vizag), Andhra Pradesh", lat: 17.6868, lng: 83.2185 },
  { name: "Belpara, Balangir, Odisha", lat: 20.4506, lng: 83.1533 },
  { name: "Rayagada, Odisha", lat: 19.1713, lng: 83.4161 },
  { name: "Berhampur, Odisha", lat: 19.3149, lng: 84.7941 },
  { name: "Balangir, Odisha", lat: 20.7075, lng: 83.4846 },
  { name: "Bhubaneswar, Odisha", lat: 20.2961, lng: 85.8245 },
  { name: "Cuttack, Odisha", lat: 20.4625, lng: 85.8828 },
  { name: "Vizianagaram, Andhra Pradesh", lat: 18.1067, lng: 83.3956 },
];

export const DEFAULT_ORIGIN = LOCATION_PRESETS[0];
export const DEFAULT_DESTINATION = LOCATION_PRESETS[1];

/** Depot position new trucks start from. */
export const FLEET_HOME = { name: "Fleet depot", lat: 18.955257, lng: 83.448556 };
